import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1dd593ee")

_pushScopeId("data-v-1dd593ee")
const _hoisted_1 = { class: "common-recipe-list" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_CommonRecipeListItem = _resolveComponent("CommonRecipeListItem")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getRecipes(_ctx.recipes), (recipe) => {
      return (_openBlock(), _createBlock(_component_CommonRecipeListItem, {
        key: recipe.recipeId,
        recipeImageUrl: recipe.imageUrl,
        recipeLabel: recipe.title,
        recipeId: recipe.recipeId,
        groupId: recipe.groupId,
        recipeType: recipe.type,
        recipeApplianceCategory: recipe.applianceCategory,
        recipeApplianceCategoryId: recipe.applianceCategoryId,
        recipeTags: recipe.tags,
        recipeFoodIds: recipe.foodIds,
        mode: _ctx.mode,
        onSelectRecipe: _ctx.selectRecipe,
        onSelectDelete: _ctx.selectDelete,
        onSelectCheck: _ctx.selectCheck,
        onSelectTag: _ctx.selectRecipeTag
      }, null, 8, ["recipeImageUrl", "recipeLabel", "recipeId", "groupId", "recipeType", "recipeApplianceCategory", "recipeApplianceCategoryId", "recipeTags", "recipeFoodIds", "mode", "onSelectRecipe", "onSelectDelete", "onSelectCheck", "onSelectTag"]))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
})